import React from "react";
import Aux from '../../atom/children';
import MarginForm from '../../atom/formMargin';
import Label from '../../atom/label/label';
import ReactDatePicker from '../../atom/DOB/reactDatePicker';
import Error from '../../atom/error';

const ReactPicker = (props) => {

    // const onBlur = (e) => {
    //const { name, value } = e.currentTarget;
    //props.onBlur(props.name, props.value)
    // }

    const onChange = (e) => props.onChange(props.name, e)

    return (
        <Aux>
            <MarginForm margin={props.margin}>
                <Label label={props.label} />
                {/* calendar-inside */}
                <div className={props.calenderInside ? "formRe datePicker bg-transparent" : "formRe datePicker"} style={props.style}>
                    <ReactDatePicker
                        name={props.name}
                        value={props.value}
                        onChange={onChange}
                        //    onBlur={onBlur}
                        placeholder={props.placeholder}
                        minDate={props.minDate}
                        maxDate={props.maxDate}
                        disabled={props.disabled}
                        class={props.class}
                        dayClassName={props.dayClassName}
                    />
                    {/* {props.icon ? <span className="icon_calender"></span> : null} */}
                    <Error errorMessage={props.errorMSg} />

                    {props.children}

                </div>
            </MarginForm>
        </Aux>
    );
};

export default ReactPicker
